var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSection',{attrs:{"id":"timesheets","type":"page","title":_vm.$t(_vm.$getConst.pages.timesheet.edit_timesheet)}},[_c('TimesheetForm',{attrs:{"timesheet-to-edit-id":_vm.timesheet_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }